const ListClients = require('./ListClients.graphql');
const CreateClient = require('./CreateClient.graphql');
const UpdateClient = require('./UpdateClient.graphql');
const DeleteClient = require('./DeleteClient.graphql');
const ListThreads = require('./ListThreads.graphql');
const CreateThread = require('./CreateThread.graphql');
const UpdateThread = require('./UpdateThread.graphql');
const AddListener = require('./AddListener.graphql');
const RemoveListener = require('./RemoveListener.graphql');
const DeleteThread = require('./DeleteThread.graphql');
const ListComments = require('./ListComments.graphql');
const CreateComment = require('./CreateComment.graphql');
const UdateComment = require('./UdateComment.graphql');
const DeleteComment = require('./DeleteComment.graphql');
const ListDashboards = require('./ListDashboards.graphql');
const CreateDashboard = require('./CreateDashboard.graphql');
const UpdateDashboard = require('./UpdateDashboard.graphql');
const DeleteDashboard = require('./DeleteDashboard.graphql');
const ListCharts = require('./ListCharts.graphql');
const CreateChart = require('./CreateChart.graphql');
const UpdateChart = require('./UpdateChart.graphql');
const DeleteChart = require('./DeleteChart.graphql');
const ListTriggerableStats = require('./ListTriggerableStats.graphql');
const CreateTriggerableStats = require('./CreateTriggerableStats.graphql');
const UpdateTriggerableStats = require('./UpdateTriggerableStats.graphql');
const DeleteTriggerableStats = require('./DeleteTriggerableStats.graphql');
const ListUnitGroups = require('./ListUnitGroups.graphql');
const CreateUnitGroup = require('./CreateUnitGroup.graphql');
const UpdateUnitGroup = require('./UpdateUnitGroup.graphql');
const DeleteUnitGroup = require('./DeleteUnitGroup.graphql');
const ListSensorTypes = require('./ListSensorTypes.graphql');
const CreateSensorType = require('./CreateSensorType.graphql');
const UpdateSensorType = require('./UpdateSensorType.graphql');
const DeleteSensorType = require('./DeleteSensorType.graphql');
const ListUnits = require('./ListUnits.graphql');
const CreateUnit = require('./CreateUnit.graphql');
const UpdateUnitSuper = require('./UpdateUnitSuper.graphql');
const UpdateUnitData = require('./UpdateUnitData.graphql');
const UpdateUnitClient = require('./UpdateUnitClient.graphql');
const DeleteUnit = require('./DeleteUnit.graphql');
const UnitSubsciption = require('./UnitSubsciption.graphql');
const ListUnitEvents = require('./ListUnitEvents.graphql');
const CreateUnitEvent = require('./CreateUnitEvent.graphql');
const DeleteUnitEvent = require('./DeleteUnitEvent.graphql');
const ListUnitSensors = require('./ListUnitSensors.graphql');
const CreateUnitSensor = require('./CreateUnitSensor.graphql');
const UpdateUnitSensorData = require('./UpdateUnitSensorData.graphql');
const UpdateUnitSensorClient = require('./UpdateUnitSensorClient.graphql');
const ResetUnitSensor = require('./ResetUnitSensor.graphql');
const DeleteUnitSensor = require('./DeleteUnitSensor.graphql');
const UnitSensorSubscription = require('./UnitSensorSubscription.graphql');
const ListActions = require('./ListActions.graphql');
const CreateAction = require('./CreateAction.graphql');
const UpdateActionData = require('./UpdateActionData.graphql');
const DeleteAction = require('./DeleteAction.graphql');
const ListUnitComms = require('./ListUnitComms.graphql');
const CreateCommCache = require('./CreateCommCache.graphql');
const UpdateCommCache = require('./UpdateCommCache.graphql');
const CommSubscription = require('./CommSubscription.graphql');
const UpdateSubscribers = require('./UpdateSubscribers.graphql');
const UpdateSubscription = require('./UpdateSubscription.graphql');
export default { 
    ListClients,
    CreateClient,
    UpdateClient,
    DeleteClient,
    ListThreads,
    CreateThread,
    UpdateThread,
    AddListener,
    RemoveListener,
    DeleteThread,
    ListComments,
    CreateComment,
    UdateComment,
    DeleteComment,
    ListDashboards,
    CreateDashboard,
    UpdateDashboard,
    DeleteDashboard,
    ListCharts,
    CreateChart,
    UpdateChart,
    DeleteChart,
    ListTriggerableStats,
    CreateTriggerableStats,
    UpdateTriggerableStats,
    DeleteTriggerableStats,
    ListUnitGroups,
    CreateUnitGroup,
    UpdateUnitGroup,
    DeleteUnitGroup,
    ListSensorTypes,
    CreateSensorType,
    UpdateSensorType,
    DeleteSensorType,
    ListUnits,
    CreateUnit,
    UpdateUnitSuper,
    UpdateUnitData,
    UpdateUnitClient,
    DeleteUnit,
    UnitSubsciption,
    ListUnitEvents,
    CreateUnitEvent,
    DeleteUnitEvent,
    ListUnitSensors,
    CreateUnitSensor,
    UpdateUnitSensorData,
    UpdateUnitSensorClient,
    ResetUnitSensor,
    DeleteUnitSensor,
    UnitSensorSubscription,
    ListActions,
    CreateAction,
    UpdateActionData,
    DeleteAction,
    ListUnitComms,
    CreateCommCache,
    UpdateCommCache,
    CommSubscription,
    UpdateSubscribers,
    UpdateSubscription
};


// WEBPACK FOOTER //
// ./src/services/graphql/queries/index.ts